import Mention from "@tiptap/extension-mention"
import { createSuggestionPopup } from "./suggestion_popup"

export function createMentionExtension(mentionsUrl) {
  const popup = createSuggestionPopup()

  return Mention.extend({
    addAttributes() {
      return {
        ...this.parent?.(),
        mentionType: {
          default: null,
          parseHTML: (element) => element.getAttribute("data-mention-type"),
          renderHTML: (attributes) => {
            if (!attributes.mentionType) return {}
            return { "data-mention-type": attributes.mentionType }
          },
        },
      }
    },
  }).configure({
    HTMLAttributes: { class: "mention" },
    suggestion: {
      char: "@",

      async items({ query }) {
        if (!mentionsUrl) return []

        try {
          const url = `${mentionsUrl}?query=${encodeURIComponent(query)}`
          const response = await fetch(url, {
            headers: { Accept: "application/json" },
          })
          if (!response.ok) return []
          const data = await response.json()
          return data.map((item) => ({
            id: item.id,
            label: item.type === "user" ? item.name : `@${item.name}`,
            mentionType: item.type === "user" ? null : item.type,
          }))
        } catch {
          return []
        }
      },

      command: ({ editor, range, props }) => {
        editor
          .chain()
          .focus()
          .insertContentAt(range, [
            {
              type: "mention",
              attrs: {
                id: props.id,
                label: props.label,
                mentionType: props.mentionType || null,
              },
            },
            { type: "text", text: " " },
          ])
          .run()
      },

      render() {
        return popup
      },
    },
  })
}
